import Vue from 'vue/dist/vue.esm.js';
import { Loader } from '@googlemaps/js-api-loader';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import markerImage from '../../../assets/images/map-marker.png';

const fadedStyle = []; // TODO: set stile to be a bit whitened out like in figma

Vue.component('aidkits', {
    template: '#aidkits',
    delimiters: ['[[', ']]'],
    props: {
        apiKey: String,
        cities: {},
    },
    data() {
        return {
            map: null,
            geocoder: null,
            markers: [],
            selectedCity: 0,
            locations: {},
            selectedLocation: null,
            isInfoPopupVisible: false,
            popupPosition: { top: '100px', right: '100px' },
            Cities: JSON.parse(this.cities),
        };
    },

    methods: {
        async initializeMap() {
            await this.fetchLocations();

            const loader = new Loader({
                apiKey: this.apiKey,
                version: 'weekly',
            });
            let _self = this;

            loader.load().then(async () => {
                _self.map = new google.maps.Map(_self.$refs.map, {
                    center: { lat: parseFloat(_self.locations[0].lat), lng: parseFloat(_self.locations[0].lng) },
                    zoom: 15,
                });
                _self.geocoder = new google.maps.Geocoder();

                const grayScaleMapType = new google.maps.StyledMapType(fadedStyle, {
                    name: "Grayed Out Map",
                });
                _self.map.mapTypes.set("gray_map", grayScaleMapType);
                _self.map.setMapTypeId("gray_map");

                await _self.updateMarkers();
            });
        },
        async fetchLocations() {
            let params = $.param({'city': this.selectedCity})
            let _self = this;
            await $.ajax({
                url: '/ajax/ajax-aid-kits?' + params,
                method: 'GET',
                dataType: 'json',
                success: async (data) => {
                    _self.locations = data.results;
                    await _self.changeMapCenter(_self.locations[0].lat, _self.locations[0].lng);
                },
                error: (error) => {
                    console.error('Error fetching locations:', error);
                },
            });
        },
        async updateMarkers() {
            this.markers.forEach((marker) => marker.setMap(null));
            this.markers = [];
            const bounds = new google.maps.LatLngBounds();

            let _self = this;
            const loader = new Loader({
                apiKey: this.apiKey,
                version: 'weekly',
            });

            // Collect marker promises
            const markerPromises = this.locations.map(async (location) => {
                return this.createCustomMarkerIcon(markerImage, location.name).then((customIcon) => {
                    const marker = new google.maps.Marker({
                        position: {lat: parseFloat(location.lat), lng: parseFloat(location.lng)},
                        map: _self.map,
                        title: location.name,
                        optimized: false,
                        icon: {
                            url: customIcon,
                            scaledSize: new google.maps.Size(160, 160),
                        }
                    });
                    bounds.extend(marker.getPosition());
                    marker.addListener('click', (event) => {
                        _self.showCustomInfoPopup(location, event.latLng);
                    });
                    return marker;
                });
            });

            // Wait for all markers to be created
            const markers = await Promise.all(markerPromises);
            this.markers = markers;

            // Add clustering
            if (this.markerClusterer) {
                this.markerClusterer.clearMarkers();
            }
            this.markerClusterer = new MarkerClusterer({
                map: this.map,
                markers: this.markers,
            });

            if (this.map) {
                this.map.fitBounds(bounds);
            }
        },
        async changeMapCenter(latitude, longitude) {
            if (this.map) {
                this.map.setCenter(new google.maps.LatLng(latitude, longitude));
            }
        },
        async selectLocation(id){
            if (this.map) {
                let location = this.locations.find(loc => loc.id === id);
                const latLng = new google.maps.LatLng(location.lat, location.lng);
                this.map.setZoom(20);
                this.showCustomInfoPopup(location, latLng);
            }
        },
        showCustomInfoPopup(location, latLng) {
            this.selectedLocation = location;
            this.isInfoPopupVisible = true;
            this.map.setCenter(latLng);
        },

        closeInfoPopup() {
            this.isInfoPopupVisible = false;
        },
        async createCustomMarkerIcon(imageUrl, text) {
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");

            const dpr = window.devicePixelRatio * 4 || 1;

            const canvasWidth = 210;
            const canvasHeight = 200;
            const imageWidth = 70;
            const imageHeight = 70;
            canvas.width = canvasWidth * dpr;
            canvas.height = canvasHeight * dpr;

            canvas.style.width = `${canvasWidth}px`;
            canvas.style.height = `${canvasHeight}px`;

            const imageX = (canvasWidth - imageWidth) / 2;
            const imageY = 60;

            context.scale(dpr, dpr);

            const image = new Image();
            image.src = imageUrl;

            return new Promise((resolve) => {
                image.onload = () => {
                    context.drawImage(image, imageX, imageY, imageWidth, imageHeight);

                    context.shadowColor =  "rgba(0, 0, 0, 0.5)";
                    context.shadowBlur = 10;
                    context.shadowOffsetX = 2;
                    context.shadowOffsetY = 2;

                    context.font = "bold 20px Arial";
                    context.fillStyle = "#002664";
                    context.textAlign = "center";

                    context.fillText("Аптечка", canvasWidth / 2, imageY + imageHeight + 25);

                    resolve(canvas.toDataURL());
                };
            });
        }
    },
    watch: {
        selectedCity(newCity) {
            this.geocoder.geocode({'address': this.Cities.find(c => c.id === newCity).text}, function(results, status) {
                if (status === 'OK') {
                    this.map.setCenter(results[0].geometry.location);
                } else {
                    console.error('Geocode was not successful for the following reason: ' + status);
                }
            });

            if (newCity) {
                this.fetchLocations();
            }
            this.isInfoPopupVisible = false;

        },
    },
    mounted() {
        this.initializeMap();
    },
});
